
























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeSoap } from "@/store/modules/soap";
import { userModule } from "@/store/modules/user";
// import ConfirmDialog from "@/components/modal/ConfirmDialog.vue";
import DateFormat from "@/utility/DateFormat";
// import CardModalTtd from "@/components/modal/CardModalTtd.vue";

@Component({
  components: {
    // CardModalTtd,
  }
})
export default class BaseSuketCard extends Vue {
  @Prop() readonly register!: string;
  @Prop() expandInput!: boolean;
  @Prop() loading!: boolean;
  @Prop() creatorUserId!: number | string;
  @Prop() signeeUserId!: number | string;
  @Prop() contentData!: Record<string, unknown>;
  @Prop() title!: string;
  @Prop({ default: false }) isReadOnly: boolean;
  @Prop({ default: false }) allowedCreate?: boolean;
  @Prop({ type: Boolean, default: true }) readonly requireSoap!: boolean;

  modalTtd = false;
  isBusy = false;

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get user() {
    return userModule.user;
  }

  get canEdit() {
    return (
      (this.user.id == this.creatorUserId ||
        this.user.id == this.signeeUserId) &&
      !this.isDocumentSigned
    );
  }

  get canSign() {
    return this.user.id == this.signeeUserId && !this.isDocumentSigned;
  }

  get canRemove() {
    return (
      this.user.id == this.creatorUserId || this.user.id == this.signeeUserId
      //   &&
      // !this.isDocumentSigned
    );
  }

  get canCreate() {
    return this.user.profesi === "Dokter" || this.allowedCreate;
  }

  get isSoapExist() {
    return this.statesoapdetail.length > 0;
  }

  get isNeedSoap() {
    // unit terlist di array ini tidak butuh soap tuk nulis suket
    return (
      this.requireSoap &&
      !["01"].includes(this.user.unit_id) &&
      this.user.unit_id < "30"
    );
  }

  get documentSignedDateTime() {
    return this.contentData.signed_at
      ? DateFormat.formatDate(this.contentData.signed_at)
      : null;
  }

  get isDocumentSigned() {
    return this.contentData.signed_at !== null;
  }

  backPageSoap() {
    this.$emit("backPageSoap");
  }

  print() {
    this.$emit("print", this.contentData.id);
  }

  edit() {
    this.$emit("showInput");
  }

  // remove() {
  // // kurang dialog konfirmasi
  //   // this.isBusy = true;

  //   //   SuketMata.destroy(id)
  //   //     .then((resp) => {
  //   //       if (resp.status) {
  //   //         appModule.NoticeDelay("Berhasil Hapus Surat Keterangan Mata");
  //   //       } else {
  //   //         alert("Mohon maaf ada kesalahan saat hapus data!");
  //   //       }

  //   //       StoreSuketMata.fetchSuketByRegister();
  //   //     })
  //   //     .finally(() => {
  //   //       this.isBusy = false;
  //   //     });
  // }

  showSignatureModal() {
    this.$emit("showSignatureModal");
  }

  remove() {
    const q = confirm(`Hapus ${this.title} ini?`);

    if (q) {
      this.$emit("removeSuket");
    }
  }
}
